export const roles = {
  // ClubHub
  betaFeaturesClubHub: 'BetaFeaturesClubHub',
  bridgingClubHub: 'BridgingClubHub',
  broker: 'Broker',
  brokerIgniteMI: 'BrokerMI',
  brokerIntegrationMi: 'BrokerIntegrationMi',
  brokerMi: 'BrokerMi',
  brokerNewKeyPartnerMI: 'BrokerNewKeyPartnerMI',
  brokerPaidMI: 'BrokerPaidMI',
  claims: 'Claims',
  claimsAdmin: 'ClaimsAdmin',
  clubHub: 'ClubHub',
  clubHubGenerateEOR: 'ClubHubGenerateEOR',
  clubHubGenerateEsisBuyToLet: 'ClubHubGenerateEsisBuyToLet',
  clubHubGenerateEsisResidential: 'ClubHubGenerateEsisResidential',
  executiveMarketSummaryMI: 'ExecutiveMarketSummaryMI',
  ignite: 'Ignite',
  igniteTesting: 'IgniteTesting',
  mortgageClub: 'MortgageClub',
  procFeeHistory: 'ProcFeeHistory',
  savedSearches: 'SavedSearches',
  ssoTesting: 'SsoTesting',
  staff: 'Staff',
  viewConsumerDuty: 'ViewConsumerDuty',

  // LenderHub
  affordabilityManager: 'AffordabilityManager',
  betaFeaturesLenderHub: 'BetaFeaturesLenderHub',
  bridgingLenderHub: 'BridgingLenderHub',
  consumerDuty: 'ConsumerDuty',
  igniteAudit: 'IgniteAudit',
  igniteBuyToLetTesting: 'IgniteBuyToLetTesting',
  lender: 'Lender',
  lenderCriteria: 'LenderCriteria',
  lenderEsisConfiguration: 'LenderEsisConfiguration',
  packager: 'Packager',
  product: 'Product',
  productsAudit: 'ProductsAudit',

  lenderPaidMi: 'LenderPaidMi',
  lenderPaidMiRoles: {
    affordabilityMi: 'AffordabilityMi',
    affordabilityMiR12: 'AffordabilityMiR12',
    bdmMiPack: 'BdmMiPack',
    bdmMiPackTrial: 'BdmMiPackTrial',
    completionsMi: 'CompletionsMi',
    criteriaMi: 'CriteriaMi',
    criteriaMiTrial: 'CriteriaMiTrial',
    criteriaSandbox: 'CriteriaSandbox',
    executiveMarketSummary: 'ExecutiveMarketSummary',
    hostedMi: 'HostedMi',
    lenderIgniteActivity: 'LenderIgniteActivity',
    lGSSLenderSpecificMI: 'LGSSLenderSpecificMI',
    lGSSNewBuildMI: 'LGSSNewBuildMI',
    paidCompletionsMi: 'PaidCompletionsMi',
    productMi: 'ProductMi',
    propertyMi: 'PropertyMi',
  },

  // Admin Dashboard
  adminDashboard: 'AdminDashboard',
  adminDashboardUserManagement: 'AdminDashboardUserManagement',
  analytics: 'Analytics',
  brokerLicenceAdmin: 'BrokerLicenceAdmin',
  clubHubUserManagement: 'ClubHubUserManagement',
  clubHubUserManagementLimited: 'ClubHubUserManagementLimited',
  criteriaManagement: 'CriteriaManagement',
  externalClientManagement: 'ExternalClientManagement',
  formManagement: 'FormManagement',
  lenderHubUserManagement: 'LenderHubUserManagement',
  lenderManagement: 'LenderManagement',
  lendingTypeManagement: 'LendingTypeManagement',
  distributionGroupManagement: 'DistributionGroupManagement',
  procFeeManagement: 'ProcFeeManagement',
  screenscrapeTesting: 'ScreenscrapeTesting',
  siteManagement: 'SiteManagement',
};
